import React, { Suspense } from "react";
import Loader from "../components/common/Loader";
import { Box } from "@mui/material";

export const lazyLoad = (importFunc) => {
  const LazyComponent = React.lazy(importFunc);

  return (props) => (
    <Suspense
      fallback={
        <Box
          width="100%"
          height="100vh"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Loader text="Loading..." />
        </Box>
      }
    >
      <LazyComponent {...props} />
    </Suspense>
  );
};
